<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Pengeluaran Semen Ternakan" >
      <w-card bg-color="" class="">
        <div class="w-flex wrap smd-column" >
          <div class="mx2"></div>
          <div class="grow ">
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                <table >
                  <tbody>
                    <tr class="row_data">
                      <td><b>Tarikh Pengeluaran</b></td>
                      <td><b>:</b></td>
                      <td>{{ $zutil.dateformat(data.tarikh)}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Nombor Ejakulasi</b></td>
                      <td><b>:</b></td>
                      <td>{{data.lkp_ejakulasi_label}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Skor Keaktifan (0-5)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.stor_keaktifan}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>% Motiliti Progresif</b></td>
                      <td><b>:</b></td>
                      <td>{{data.motiliti}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Kepekatan Sperma (/ml)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.label_kepekatan_sperma}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Kepekatan Sperma (Per straw) * (X10^6)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.label_kepekatan_straw}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Ispadu Extender (ml) * (X10^6)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.isipadu_extender}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Nama Pemeriksaan dan Penilai</b></td>
                      <td><b>:</b></td>
                      <td>{{data.name}}</td>
                    </tr>
                    <tr class="row_data">
                      <td ><b>Catatan</b></td>
                      <td><b>:</b></td>
                      <td>{{data.catatan}}</td>
                    </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
                <table >
                  <tbody>
                    <tr class="row_data">
                      <td><b>Nombor Batch</b></td>
                      <td><b>:</b></td>
                      <td>{{data.no_batch}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>ID Ternakan</b></td>
                      <td><b>:</b></td>
                      <td>{{data.ternakan}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Isipadu Semen (ml)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.isipadu}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Jumlah Extender A (ml)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.jumlah_extender_a}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Jumlah Extender B (ml)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.jumlah_extender_b}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>% Motiliti Progresif (sejuk)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.motiliti_sejuk}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>% Motiliti Progresif (beku)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.motiliti_beku}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Jumlah Straw Dipungut</b></td>
                      <td><b>:</b></td>
                      <td>{{data.jumlah_straw}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Jumlah Straw Dikeluarkan</b></td>
                      <td><b>:</b></td>
                      <td>{{data.jumlah_pengeluaran}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Status</b></td>
                      <td><b>:</b></td>
                      <td>{{data.status}}</td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>


              <br>
            <!-- <w-flex class="flex justify-right" v-if="$zutil.role('1') || $zutil.role('6')">
             <w-button  bg-color="warning"  :route="$route('se.pengeluaran.form',data.id)" class="be fs-2">
                <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini 
              </w-button>
            </w-flex> -->
          </div>
        </div>
        <!-- <template v-if="data.jantina == 1">
        <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
          <template #item-content.1>
            <Premis :data="data" v-if="data.id > 0"/>
          </template>
          <template #item-content.2>
             <Pengambilan :data="data" v-if="data.id > 0"/>
          </template>
          <template #item-content.3>
             <FertilitiJantan :data="data" v-if="data.id > 0"/>
          </template>
        </w-tabs>
        </template>
        <template v-else>
        <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
          
          <template #item-content.1>
          </template>
          <template #item-content.2>
          </template>
        </w-tabs>
        </template> -->
      </w-card>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import Pengambilan from './Show/Pengambilan.vue';

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'se.pengeluaran',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pengeluaran Semen Ternakan', route: '/se/pengeluaran' },
        { label: 'Papar', route: '/se/pengeluaran/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      tabs: [
      		  { title: 'Pengeluaran', content: '' },
          ]
    }
  },
  methods: {
    getData()
    {
      this.$zcomm.get(this.api_service + 'se_pengeluaran/show/'+this.id, {}).then(res => {
        this.data = res
        this.getAttahecment()
        // this.listTabs()
      })

    },
    tutup(){
      this.$inertia.visit(window.route('se.pengeluaran.index'));
    },
    // listTabs(){
    //   if(this.data.jantina == 1){
    //     this.tabs = [
            
    //         { title: 'Pemungutan', content: '' },
    //         { title: 'Fertiliti Jantan', content: '' },
    //       ]
    //   }else{
    //     this.tabs = [
    //         { title: 'Pemungutan', content: '' },
    //         { title: 'Fertiliti Betina', content: '' },
    //       ]
    //   }
    // },

    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.data.id, model : '\\App\\Model\\SePemungutan'}).then(res => {
        this.attahecment = res
        this.slides = [];
       for (var b in this.attahecment) {
          this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
       }
      })
    },

    

    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",item);
       formData.append("model_id", this.data.id);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },

   
   

  },
  watch: {

  },
  mounted() {
    this.getData();
  },
}
</script>
<style scoped>



table {
  width: 100%;
  border-collapse: collapse;
}

.row_data td {
  padding: 6px 4px;
  font-size: 14px;
  color: #333;
  vertical-align: top;
}


.row_data td:first-child {
  width: 250px;       
  font-weight: 600;
  padding-right: 10px;
}

/* Kolom ":" */
.row_data td:nth-child(2) {
  width: 12px;
  text-align: center;
  font-weight: bold;
}

/* Kolom isi */
.row_data td:last-child {
  font-weight: 500;
}


</style>
